import { useParams } from "react-router";
import { BatchResults } from "@/app/(app)/batch/[batchId]/_components/batch-results";
import NotFoundPage from "../_errors/NotFoundPage";

export default function BatchDetailPage() {
  const { batchId } = useParams();
  if (!batchId) return <NotFoundPage />;
  return <BatchResults batchId={batchId} />;
}
